<mat-form-field class="date-picker">
    <mat-label>Workout date</mat-label>
    <input matInput [matDatepicker]="dp3" [(ngModel)]="selectedDate" disabled>
    <mat-datepicker-toggle matIconSuffix [for]="dp3"></mat-datepicker-toggle>
    <mat-datepicker #dp3 touchUi disabled="false"></mat-datepicker>
</mat-form-field>

<app-workout [date]="date" [movementGroups]="movementGroups"></app-workout>